import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
export const MADRID = 'Europe/Madrid';
export const dateInputFormat = 'YYYY-MM-DD HH:mm:ss';
export const madridNow = () => dayjs().tz(MADRID).format(dateInputFormat);
export const toMadridInput = value => value ? dayjs(value).tz(MADRID).format(dateInputFormat) : '';
export const toMadridISO = value => dayjs.tz(value, MADRID).format();

export function validateAbsenceRange(fromDate, toDate) {
  if (!fromDate || !toDate) return 'Complete las fechas de inicio y fin.';
  try {
    const from = dayjs.tz(fromDate, MADRID);
    const to = dayjs.tz(toDate, MADRID);
    if (!from.isValid() || !to.isValid() || !to.isAfter(from)) {
      return 'Hasta debe ser posterior a Desde.';
    }
  } catch {
    return 'Indique fechas válidas.';
  }
  return '';
}
export function absenceApiError(error) {
  const data = error?.response?.data;
  const message = data?.message || data?.detail || error?.message || 'No se ha podido guardar. Inténtelo de nuevo.';
  const existing = data?.details;
  if (data?.errorCode === 'absence_overlap' && existing?.fromDate && existing?.toDate) {
    return message + ' Ausencia existente: ' + dayjs(existing.fromDate).tz(MADRID).format('DD/MM/YYYY HH:mm') +
      ' — ' + dayjs(existing.toDate).tz(MADRID).format('DD/MM/YYYY HH:mm') + (existing.typeName ? ' (' + existing.typeName + ').' : '.');
  }
  if (error?.response?.status === 403) return 'No tienes permiso para modificar esta ausencia.';
  if (error?.response?.status === 422) {
    const violations = Array.isArray(data?.violations)
      ? data.violations.map(item => item.message).filter(Boolean).join(' ') : '';
    return data?.message || data?.detail || violations ||
      'No se han podido guardar los cambios. Revisa las fechas y los justificantes.';
  }
  return message;
}

const WORK_RECORD_TYPE_LABELS = { entry: 'Entrada', pause: 'Parada', resume: 'Reanudación', exit: 'Salida' };

/**
 * Error al aprobar/rechazar solicitudes de fichaje (individual o en bloque).
 * Devuelve { message, blockedIds }: blockedIds solo viene informado cuando el errorCode es
 * absence_required_via_pause_button, para que el componente pueda señalar qué solicitudes concretas
 * no se pueden aprobar (generarían una ausencia médica/otros nueva, algo reservado al botón "Parar").
 * El mensaje ya incluye, entre paréntesis, el tipo y la fecha/hora de cada una (details.items del
 * backend), no solo el id — así ningún consumidor necesita correlacionarlo con datos locales.
 */
export function workRecordRequestApiError(error) {
  const data = error?.response?.data;
  const message = data?.message || data?.detail || error?.message || 'No se ha podido procesar la solicitud. Inténtelo de nuevo.';

  if (data?.errorCode === 'absence_required_via_pause_button') {
    const items = Array.isArray(data?.details?.items) ? data.details.items : [];
    const blockedIds = Array.isArray(data?.details?.ids) ? data.details.ids : items.map(item => item.id);
    const detail = items
      .map(item => (WORK_RECORD_TYPE_LABELS[item.type] || item.type)
        + (item.requestedRecordedAt ? ' ' + dayjs(item.requestedRecordedAt).tz(MADRID).format('DD/MM/YYYY HH:mm') : ''))
      .join(', ');

    return {
      message: 'No se puede aprobar: ' + (blockedIds.length > 1
        ? blockedIds.length + ' solicitudes generarían una ausencia médica/otros nueva'
        : 'la solicitud generaría una ausencia médica/otros nueva')
        + '. Esas ausencias solo pueden crearse pausando la jornada en tiempo real desde Presencia.'
        + (detail ? ' (' + detail + ')' : ''),
      blockedIds,
    };
  }

  if (error?.response?.status === 403) return { message: 'No tienes permiso para revisar esta solicitud.', blockedIds: [] };
  return { message, blockedIds: [] };
}
